import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScoreProvider from './store/ScoreProvider';
import {BrowserRouter, Routes, Route} from "react-router-dom";

import Login from "./login/Login";
import Calendar from "./calendar/Calendar";
import Help from "./help/Help";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScoreProvider>
        <BrowserRouter>
            <Routes>
                <Route path='/home' element={<App/>}/>


                <Route  path='/' element={<Login/>}/>
                <Route exact  path='login' element={<Login/>}/>
                <Route  path='calendar' element={<Calendar/>}/>
                <Route  path='help' element={<Help/>}/>
            </Routes>

        </BrowserRouter>

    </ScoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
